import * as Sentry from '@sentry/react';

type InitMonitoringOptions = {
  dsn?: string;
  environment?: string;
  enabled?: boolean;
  tracesSampleRate?: number;
  profilesSampleRate?: number;
  release?: string;
  dist?: string;
};

const defaultDsn = import.meta.env.VITE_SENTRY_DSN;
const defaultEnvironment = import.meta.env.MODE;
const defaultRelease = import.meta.env.VITE_SENTRY_RELEASE;
const defaultDist = import.meta.env.VITE_SENTRY_DIST;

/**
 * Initialize monitoring and performance tracing if a DSN is configured.
 * Defaults to production-only to avoid noise during local development/tests.
 */
export function initMonitoring(options: InitMonitoringOptions = {}): void {
  const {
    dsn = defaultDsn,
    environment = defaultEnvironment,
    enabled = import.meta.env.PROD && Boolean(dsn),
    tracesSampleRate = 1.0,
    profilesSampleRate = 0.1,
    release = defaultRelease,
    dist = defaultDist,
  } = options;

  if (!enabled || !dsn) {
    return;
  }

  Sentry.init({
    dsn,
    environment,
    tracesSampleRate,
    profilesSampleRate,
    release,
    dist,
  });
}
